var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit.apply(null, arguments)}}},[_c('v-btn',{attrs:{"color":"primary","type":"submit"}},[_vm._v("Continue")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }